import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { AuditLogLite } from '../+models/trip-audit.model';

@Component({
  selector: 'sd-portal-audit-detail-list-v2',
  templateUrl: './audit-detail-list-v2.component.html',
  styleUrls: ['./audit-detail-list-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuditDetailListV2Component implements OnInit {
  // Inputs
  @Input() isTall: boolean = false;
  @Input() loading: boolean = false;
  @Input() loaded: boolean = true;
  @Input() audits: AuditLogLite[];
  @Input() hasMore: boolean = false;
  @Input() noAuditsMessage: string = 'No audit records';

  // Outputs
  @Output() nextPage = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}
}
